export default __webpack_public_path__ + "static/1532-f3d23a6ad0dc91d43324a9cb4d345dc7.gif";